module.exports = __webpack_public_path__ + "static/media/PDF_EN_1.4490dcd1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/PDF_EN_1.pdf
// module id = 678
// module chunks = 0